{
  "version": 1,
  "asset_id": "753b7e5a-467c-4261-9303-30cc042db4a9",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/753b7e5a-467c-4261-9303-30cc042db4a9/groen-water-800.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/753b7e5a-467c-4261-9303-30cc042db4a9/groen-water-800.avif",
  "original_filename": "groen-water-800.avif",
  "size": 11211,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:05:47Z"
}
